// src/components/HowToStay.jsx
import React from 'react';
import './HowToStay.css';
import { motion } from 'framer-motion';

const HowToStay = ({ isEnglish }) => {
  // アンカーリンク用の関数
  const scrollToBooking = (e) => {
    e.preventDefault();
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const steps_ja = [
    {
      step: 'Step 1',
      title: 'ご予約',
      image: '/images/steps/step1.jpg',
      description: (
        <>
          公式サイトからのご予約が<strong>最もお得（ベストレート）</strong>です。
          <br />
          <a href="#booking" onClick={scrollToBooking} className="booking-link">
            ▶ 公式サイトで空室検索・予約
          </a>
        </>
      ),
    },
    // ... 他のステップは変更なし ...
    {
      step: 'Step 2',
      title: 'チェックイン当日',
      image: '/images/steps/step2.jpg',
      description: <>チェックインは <strong>15:00〜18:00</strong> です。<br />ご案内メールを当日お送りします。<br /><small>※18時を過ぎる場合は事前にご連絡ください。</small></>
    },
    {
      step: 'Step 3',
      title: 'チェックイン',
      image: '/images/steps/step3.jpg',
      description: <>玄関のタッチパネルに暗証番号を入力、<br />ご入室確認後、スタッフがご案内に伺います。</>
    },
    {
      step: 'Step 4',
      title: 'ご滞在',
      image: '/images/steps/step4.jpg',
      description: <>ゆっくりとご滞在をお楽しみください。</>
    },
    {
      step: 'Step 5',
      title: 'チェックアウト',
      image: '/images/steps/step5.jpg',
      description: <><strong>午前10時</strong>までにチェックアウトをお願します。<br />室内設置のQRコードからお手続きください。<br />お気をつけてお帰りください。</>
    },
  ];

  const steps_en = [
    {
      step: 'Step 1',
      title: 'Booking',
      image: '/images/steps/step1.jpg',
      description: (
        <>
          We guarantee the <strong>Best Rate</strong> on our official website.
          <br />
          <a href="#booking" onClick={scrollToBooking} className="booking-link">
            ▶ Check Availability & Book
          </a>
        </>
      ),
    },
    // ... 他のステップは変更なし ...
    {
      step: 'Step 2', title: 'Arrival Day', image: '/images/steps/step2.jpg',
      description: <>Check-in is from <strong>3:00 PM to 6:00 PM</strong>.<br />You will receive an email with a passcode.<br /><small>*Please contact us if you'll arrive after 6 PM.</small></>
    },
    {
      step: 'Step 3', title: 'Check-in', image: '/images/steps/step3.jpg',
      description: <>Enter the passcode on the panel at the entrance.<br />Our staff will visit and explain the facilities.</>
    },
    {
      step: 'Step 4', title: 'Stay', image: '/images/steps/step4.jpg',
      description: <>Please enjoy your stay.</>
    },
    {
      step: 'Step 5', title: 'Check-out', image: '/images/steps/step5.jpg',
      description: <>Please check out by <strong>10:00 AM</strong>.<br />Use the QR code to complete checkout.<br />Safe travels!</>
    }
  ];

  const steps = isEnglish ? steps_en : steps_ja;

  return (
    <>
      <section
        className="howto-hero"
        style={{ backgroundImage: "url('/images/howto-hero.jpg')" }}
      >
        <div className="howto-hero-overlay">
          <h1 className="howto-hero-title">
            {isEnglish ? 'How to Stay' : 'ご利用の流れ'}
          </h1>
        </div>
      </section>

      <section className="how-to-stay">
        <div className="step-container">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="step-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="step-text">
                <div className="step-label">{step.step}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              <div className="step-image-wrapper">
                <img src={step.image} alt={step.title} className="step-image" />
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </>
  );
};

export default HowToStay;